
import { getUrlApi } from '../utilities/util';
import ApiHandler from './ApiHandlers/ApiHandler'; 

export const baseURL = String(getUrlApi());

export default class DeviceApi { 
    static async GetAllDevices(): Promise<any> {
        return ApiHandler(baseURL).get("/device/getalldevices");
    };   

    static async GetDeviceById(id: number): Promise<any> {
        return ApiHandler(baseURL).get("/device/getdevicebyid/Id=" + id);
    }; 

    static async GetDevicesByStationId(stationId: number): Promise<any> {
        return ApiHandler(baseURL).get(`/device/getdevicesbystationid?stationId=${stationId}`);;
    };  
    
    static async CreateDevice(stationId: string, description: string, name: string): Promise<any> { 
        return ApiHandler(baseURL).post("/device/devicecreate", { stationId, description, name})
    }

    static async UpdateDevice(id: string, stationId: string, description: string, name: string): Promise<any> { 
        return ApiHandler(baseURL).post("/device/deviceupdate", { stationId, description, name, id })
    }

    static async VideoDeviceDetectionTrigger(stationId?: string, deviceId?: string): Promise<any> { 
        return ApiHandler(baseURL).post("/device/videodevicedetectiontrigger", { stationId, deviceId })
    }

    static async DeleteDevice(deviceId: string): Promise<any> {
        return ApiHandler(baseURL).post(`/device/devicedelete`, deviceId, {
            headers: {
                'Content-Type': 'application/json-patch+json',
            },
        });
    }
}
